import Box from "@mui/material/Box";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PaymentsIcon from "@mui/icons-material/Payment";
import Title from "../components/Title";
import { colors, USER_DATA } from "../utils/constants";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Loading from "../components/Loading";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
import { getPayments } from "../api/payments";
import ButtonLoading from "../components/ButtonLoading";

// const stripePromise = loadStripe(
//   "pk_test_51QoY7NE2yDzOSq6EqhcBoHF2JYc2uD1kIoP9S18K9ebNuWRl4OOLmFfG2XXpIHphw2pGKxv2UoCiOFXRUApYDkDX00fPn92ZWh"
// ); // Sua chave pública

const stripePromise = loadStripe(
  "pk_live_51QoY7NE2yDzOSq6E5Ppr1DUHkrhogJuD4s4aLIJvrdHK5A5RmB500TDpNZhzf3jx2C4v8Ff0AeSvKWGkHc47iPOe00oU0mtO4M"
); // Sua chave pública - PROD

export default function Payments() {
  const navigate = useNavigate();

  const { client_id } = useParams();

  const [payments, setPayments] = useState<any[]>([]);
  const [status, setStatus] = useState("");
  const [subscriptionStatus, setSubscriptionStatus] = useState(
    JSON.parse(localStorage.getItem(USER_DATA) || "{}").subscriptionStatus
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = () => {
    if (client_id) {
      getPayments(JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid).then(
        (response) => {
          setPayments(response);
          setLoading(false);
        }
      );
    } else {
      console.error("client_id is undefined");
      setLoading(false);
    }
  };

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get(
      "session_id"
    );

    const checkPaymentStatus = async () => {
      const response = await fetch(
        // "http://192.168.1.11:9000/check-payment-status",
        "https://qazando-pay-afb08745de64.herokuapp.com/check-payment-status",
        {
          method: "POST",
          body: JSON.stringify({ sessionId }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      setStatus(result.data.payment_status);

      if (result.data.payment_status == "paid") {
        const userData = JSON.parse(localStorage.getItem(USER_DATA) || "{}");
        userData.subscriptionStatus = "ativo"; // Altere para o valor desejado
        localStorage.setItem(USER_DATA, JSON.stringify(userData));
        setSubscriptionStatus("ativo");
      }
    };

    if (sessionId) {
      checkPaymentStatus();
    }
  }, []);

  const getStatus = (status: string) => {
    switch (status) {
      case "pago":
        return "✅ Pago";
      case "falhou":
        return "⚠️ Falhou";
      case "cancelado":
        return "🚨 Cancelado";
      default:
        return status;
    }
  };

  const handleCheckout = async () => {
    const response = await fetch(
      // "http://192.168.1.11:9000/create-checkout-session",
      "https://qazando-pay-afb08745de64.herokuapp.com/create-checkout-session",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // 📌 Definir o tipo de conteúdo como JSON
        },
        body: JSON.stringify({
          user: {
            email: JSON.parse(localStorage.getItem(USER_DATA) || "{}").email,
            user_uuid: JSON.parse(localStorage.getItem(USER_DATA) || "{}").uid,
          },
          product: "price_1Qpsk8E2yDzOSq6EvsZx8e5k",
          client_id: "qazando",
        }),
      }
    );
    const session = await response.json();

    // essa sessão será usada para o checkout
    // deve ser armazenada no banco amarrada com o usuario
    // para fazer a conciliação de pagamento
    console.log("sessão criada: ", session);

    // Redirecionando para o checkout do Stripe
    const stripe = await stripePromise;
    if (stripe) {
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (result.error) {
        alert(result.error.message);
      }
    } else {
      console.error("Stripe has not been initialized.");
    }
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        <Title text="Pagamentos" icon={<PaymentsIcon color="primary" />} />
        <Box sx={{ width: "100%" }}>
          <ButtonLoading
            onClick={handleCheckout}
            label="Assinar Agora por R$59,90"
            style={{ width: 280 }}
            disabled={subscriptionStatus == "ativo" ? true : false}
          />
          {JSON.parse(localStorage.getItem(USER_DATA) || "{}")
            .subscriptionStatus == "ativo" && (
            <ButtonLoading
              onClick={() => {
                window.open(
                  "https://api.whatsapp.com/send?phone=+5548991929692&text=Olá! Sou assinante do Certifyme e quero cancelar minha assinatura.",
                  "_blank"
                );
              }}
              label="Cancelar assinatura"
              style={{ width: 280 }}
              isDelete
            />
          )}
        </Box>
        {status == "paid" && (
          <Box
            sx={{
              marginTop: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
              backgroundColor: "#E5FFE6C6",
              borderRadius: 2,
              border: "3px solid #00D807CE",
            }}
          >
            <span style={{ color: colors.black, fontWeight: 500 }}>
              ✅ Pagamento realizado com sucesso!
            </span>
          </Box>
        )}{" "}
        {status == "unpaid" && (
          <Box
            sx={{
              marginTop: 2,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
              backgroundColor: "#FFFDE5C6",
              borderRadius: 2,
              border: "3px solid #FFF200CE",
            }}
          >
            <span style={{ color: colors.black, fontWeight: 500 }}>
              ⚠️ Pagamento não realizado!
            </span>
          </Box>
        )}
        <TableContainer sx={{ mt: 6 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ backgroundColor: colors.background }}>
                <TableCell
                  align="center"
                  sx={{ backgroundColor: colors.background }}
                >
                  Data
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ backgroundColor: colors.background }}
                >
                  Valor
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ backgroundColor: colors.background }}
                >
                  Situação
                </TableCell>
              </TableRow>
            </TableHead>

            {loading && <Loading text="Carregando pagamentos..." />}

            {!loading && (
              <TableBody>
                {payments &&
                  payments.length > 0 &&
                  payments.map((payment: any) => (
                    <TableRow key={payment.id}>
                      <TableCell align="center">
                        {moment(payment.createdAt.toDate())
                          .tz("America/Sao_Paulo")
                          .format("DD/MM/YYYY HH:mm:ss")}
                      </TableCell>
                      <TableCell align="center">
                        {payment.amount_paid &&
                          (payment.amount_paid / 100).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                      </TableCell>
                      <TableCell align="center">
                        {getStatus(payment.status)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

const isMobile = window.innerWidth < 768;

const styles: any = {
  container: {
    paddingTop: 10,
    marginLeft: isMobile ? 10 : 5,
    paddingLeft: isMobile ? 2 : 0,
    paddingRight: isMobile ? 2 : 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "start",
    marginTop: 6,
  },
};
